// extracted by mini-css-extract-plugin
module.exports = {"addressItem":"contractSimplified_addressItem__1-_uz","addressSection":"contractSimplified_addressSection__2V4mb"};